import { Directive } from '@angular/core';
import { NSagepay } from '../sagepay.namespace';
import { SagepayPiComponentDef } from './sagepay-pi.component.def';

@Directive()
export abstract class SagepayPiFormComponentDef<D extends NSagepay.ICreditCardData = NSagepay.ICreditCardData> extends SagepayPiComponentDef<
    NSagepay.IOwnFormCheckoutSubmissionPaymentData,
    D
> {
    /**
     * Returns card details from form
     * @returns {NSagepay.IOwnFormTokeniseOptionsCardDetails}
     */
    protected getCardDetails(data: D): NSagepay.IOwnFormTokeniseOptionsCardDetails {
        return {
            cardholderName: this.getCcOwner(data) || 'N/A',
            cardNumber: this.getCcNumber(data),
            expiryDate: `00${this.getExpiryMonth(data)}`.slice(-2) + `0000${this.getExpiryYear(data)}`.slice(-2),
            securityCode: this.getCvc(data)
        };
    }

    /**
     * Returns checkout submission payment data
     * @param {NSagepay.IOwnFormTokeniseResult} tokeniseResult
     * @param {string} merchantKey
     * @returns {NSagepay.IOwnFormCheckoutSubmissionPaymentData}
     */
    protected getSubmissionPaymentData(
        tokeniseResult: NSagepay.ITokeniseResult,
        merchantKey: string
    ): NSagepay.IOwnFormCheckoutSubmissionPaymentData {
        return {
            method: this.methodCode,
            additional_data: {
                'card-identifier': tokeniseResult.cardIdentifier as string,
                'sesion-key': merchantKey,
                cc_type: this.ccType,
                cc_year: this.data.expiryYear,
                cc_month: this.data.expiryMonth,
                cc_last_4: this.getLast4(),
                store_cc: this.storeCard(),
                ...this.sagepayPiService.getBrowserInfo()
            }
        };
    }

    protected getTokeniseResult(merchantKeyResponse: NSagepay.IMerchantKeyResponse, data: D): Promise<NSagepay.ITokeniseResult> {
        return this.sagepayPiService.tokeniseOwnFormCardDetails(merchantKeyResponse?.spMerchantKey, this.getCardDetails(data));
    }
}